













































































































































import { Component, mixins } from 'nuxt-property-decorator'
import { filterLinkToProductReviews } from '~/assets/filters/products'
import MixinProductCard from '~/assets/mixins/product-card'
import ComponentProductAvailable from '~/components/products/product-available.vue'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'
import ComponentRating from '~/components/rating/rating.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentProductAspects from '~/components/products/product-aspects.vue'
import ComponentProductFeature from '~/components/products/product-feature.vue'
import ComponentProductMoreDetailsLink from '~/components/products/product-more-details-link.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentAddToCompareIconButton from '~/components/products/product-add-to-compare-icon-button.vue'
import ComponentProductCardImage from '~/components/products/card/product-card-image.vue'
import ComponentProductFavouriteButton from '~/components/products/card/product-favourite-button.vue'
import ComponentProductQuickViewButton from '~/components/products/card/product-quick-view-button.vue'
import ComponentProductBonus from '~/components/products/card/product-bonus.vue'

// Список каталога: фото слева, описание в середине, цены и кнопки справа.
@Component({
  filters: {
    filterLinkToProductReviews,
  },
  components: {
    ComponentProductAvailable,
    ComponentProductBuyButton,
    ComponentRating,
    ComponentCatalogLabels,
    ComponentProductAspects,
    ComponentProductFeature,
    ComponentProductMoreDetailsLink,
    ComponentProductDetailPricesLight,
    ComponentAddToCompareIconButton,
    ComponentProductCardImage,
    ComponentProductFavouriteButton,
    ComponentProductQuickViewButton,
    ComponentProductBonus,
  },
})
export default class ComponentProductItem3 extends mixins(MixinProductCard) {
  private get classWrapper() {
    return {
      [this.$style.product]: true,
      [this.$style.disable]: !this.item.inStock,
      [this.$style.trafaret]: this.item.trafaret,
      [this.$style.shadow]: this.isProductShadow,
      ...this.classDevice(this.$style),
    }
  }
}
